import {
    GET_FLEET_DISPOSITION_SAVE,
    SET_FLEET_DISPOSITION_SAVE
} from "./FleetDispositionSaveType"

const getSaveFleetDisposition = (fleetdispositionSave: any) => ({
    type: GET_FLEET_DISPOSITION_SAVE,
    fleetdispositionSave
})

const setSaveFleetDisposition = (fleetDispositionValue: any) => ({
    type: SET_FLEET_DISPOSITION_SAVE,
    fleetDispositionValue: fleetDispositionValue
})

export {
    getSaveFleetDisposition,
    setSaveFleetDisposition
}